var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-widget',{attrs:{"model":_vm.model,"attribute":_vm.attribute,"items":_vm.items,"type":"select2","value-field":"key","label":_vm.label,"options":_vm.computedOptions,"multiple":_vm.multiple,"display-field":"${item.text}"}})}
var staticRenderFns = []

export { render, staticRenderFns }